import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { premiumButtonSx } from 'common/theme/button/premiumButtonSx';
import routes from 'common/routes';

/**
 * Aviso para el cliente que NO puede crear sesión (sin plan activo / sin sesiones): recomienda
 * pagar o seleccionar un plan y lo lleva a su plan. Monocromo + CTA premium.
 */
function NoActivePlanModal({ open, onClose }) {
  const { t } = useTranslation(['sessions', 'buttons']);
  const navigate = useNavigate();

  const goToPlans = () => {
    onClose();
    navigate(routes.myPlanStatus.path);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'surface.raised',
          backgroundImage: 'none',
          border: '1px solid',
          borderColor: 'hairline.main',
          borderRadius: 3
        }
      }}>
      <DialogContent sx={{ textAlign: 'center', py: 4, px: 3 }}>
        <Box sx={{ color: 'gold.main', mb: 1.5, display: 'flex', justifyContent: 'center' }}>
          <ErrorOutline sx={{ fontSize: 56 }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
          {t('noActivePlan.title', { ns: 'sessions', defaultValue: 'No puedes crear una sesión' })}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          {t('noActivePlan.message', {
            ns: 'sessions',
            defaultValue:
              'No tienes un plan activo o se acabaron tus sesiones. Te recomendamos pagar o seleccionar un plan.'
          })}
        </Typography>
        <Stack spacing={1.25}>
          <Button fullWidth onClick={goToPlans} sx={{ ...premiumButtonSx, py: 1 }}>
            {t('viewPlans', { ns: 'buttons', defaultValue: 'Ver planes' })}
          </Button>
          <Button
            fullWidth
            variant="text"
            color="inherit"
            onClick={onClose}
            sx={{ color: 'text.secondary', textTransform: 'none', fontWeight: 700 }}>
            {t('close', { ns: 'buttons', defaultValue: 'Cerrar' })}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

NoActivePlanModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default NoActivePlanModal;
